import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';
import { VehicleBanSeverity } from './vehicle-bans';

export class IVehicle {
  id: string | number;
  code: string;
  code2: string;
  brand: string;
  model: string;
  weight: number;
  deci: number;
  description: string;
  hidden: number;
  categoryId: string | number;
  countryId: string | number;
  pointId: string | number | null;
  year: number | null;
  logo: number;
  filt?: number;
  isBanned?: number;
  banSeverity?: VehicleBanSeverity | null;
}

export class IVehicleResponse {
  @Type(() => IVehicle)
  result: IVehicle;
}

export class IVehlicleListResponse extends IPagination {
  @Type(() => IVehicle)
  results: IVehicle[];
}

export class IVehicleQueryDto extends IQueryPaginationDto {
  /** 1: marka/model/kategori eksik araçlar (eski otomatik transfer kayıtları) */
  incomplete?: number;
  code?: string;
  code2?: string;
  brand?: string;
  model?: string;
  categoryId?: number | string;
  countryId?: number | string;
  hidden?: number;
  year?: number;
  logo?: number;
  filt?: number;
}

export class IVehicleCategory {
  id: string | number;
  name: string;
  @Type(() => Date)
  date: Date;
}

export class IVehicleCategoryListResponse extends IPagination {
  @Type(() => IVehicleCategory)
  results: IVehicleCategory[];
}

export class IVehicleCategoryQueryDto extends IQueryPaginationDto {
  name: string;
}

export class IVehicleCategoryResponse {
  @Type(() => IVehicleCategory)
  result: IVehicleCategory;
}

export class IVehiclePatchBodyDto {
  code?: string;
  code2?: string;
  brand?: string;
  model?: string;
  weight?: number;
  deci?: number;
  description?: string;
  hidden?: number;
  categoryId?: string | number;
  countryId?: string | number;
  pointId?: string | number | null;
  year?: number | null;
  logo?: number;
  filt?: number;
}
export class IPostVehicleBodyDto {
  code: string;
  code2: string;
  brand: string;
  model: string;
  weight: number;
  deci: number;
  description: string;
  hidden: number;
  categoryId: string | number;
  countryId: string | number;
  pointId?: string | number | null;
  year?: number | null;
  logo: number;
  filt?: number;
}

export class IVehicleCategoryPatchBodyDto {
  name: string;
  date?: string;
}
export class IPostVehicleCategoryBodyDto {
  name: string;
  date: string;
}

/** GET vehicles/lookup/:plate — Transfer Araç Giriş adım 1 */
export class IVehicleLookupResponse {
  found: boolean;
  incomplete: boolean;
  missing: ('brand' | 'model' | 'category')[];
  normalizedPlate: string;
  @Type(() => IVehicle)
  vehicle: IVehicle | null;
}
